import { EntityStatusBadgeVariant } from '@frontend/common';
import React from 'react';

import { ENTITY_STATUS_BADGE_STYLES } from './entity-status-badge.styles';

export interface EntityStatusBadgeProps {
    label: React.ReactNode;
    variant: EntityStatusBadgeVariant;
    id?: string;
}

const ID = 'entity-status-badge';

export const EntityStatusBadge = (props: EntityStatusBadgeProps) => {
    const style = ENTITY_STATUS_BADGE_STYLES[props.variant];

    return (
        <div
            id={props.id}
            data-testid={props.id ?? ID}
            data-variant={props.variant}
            className={`inline-flex items-center justify-center gap-1.5 rounded-full px-2.5 py-1 ${style.container}`}>
            <span
                data-testid={`${props.id ?? ID}-dot`}
                data-hollow={style.hollowDot ? 'true' : 'false'}
                className={`size-1.5 shrink-0 rounded-full ${style.dot}`}
                aria-hidden='true'
            />
            <span className={`justify-start text-center text-sm font-semibold ${style.label}`}>{props.label}</span>
        </div>
    );
};
